import Vue from 'vue'
import VueRouterBackButton from 'vue-router-back-button'
import VueRouter from 'vue-router'
import store from '@/store/index.js'

import Signin from '@/views/signin'
import NotFound from '@/views/notFound'
import Forbidden from '@/views/forbidden'

import Home from '@/views/home/index.vue'
import Avisos from '@/views/avisos/index.vue'
import MettingRooms from '@/views/meetingRooms'
import Locations from '@/views/locations'
import Maps from '@/views/maps'
import Attributes from '@/views/attributes'
import Parking from '@/views/parking'
import Users from '@/views/users'
import Menu from '@/views/menu'
import SubMenu from '@/views/submenu'
import Dashboard from '@/views/dashboard'
import MapsRooms from '@/views/mapsRooms'
import PictureRooms from '@/views/pictureRooms'
import AttributesByItem from '@/views/attributesByRooms'
import CarsForReservation from '@/views/carsForReservation'
import SurveyDashboard from '@/views/surveyDashboard'
import BikesForReservation from '@/views/bikesForReservation'
import CarsReport from '@/views/carsReport'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [{
            name: 'signin',
            path: '/signin',
            component: Signin,
            children: null,
        },
        {
            name: 'AttributesByItem',
            path: '/attributesByItem/:idMeetingRoom/:idLocation/:idItemType',
            component: AttributesByItem,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: ['*']
            },
            children: null,
        },
        {
            name: '404',
            path: '/404',
            component: NotFound,
            children: null,
        },
        {
            name: '403',
            path: '/403',
            component: Forbidden,
            children: null,
        },
        {
            name: 'home',
            path: '/',
            component: Home,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: ['*']
            },
            children: null,
        },
        {
            name: 'meetingRooms',
            path: '/rooms/:idLocation',
            component: MettingRooms,
            icon: 'mdi-seat-recline-normal',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: ['*']
            },
            children: [],
        },
        {
            name: 'room map',
            path: '/mapsRooms',
            component: MapsRooms,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2]
            },
            children: [],
        },
        {
            name: 'picture Rooms',
            path: '/pictureRooms/:itemId/:nombre',
            component: PictureRooms,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: ['*']
            },
            children: [],
        },
        {
            name: 'attributes',
            path: '/attributes/',
            component: Attributes,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2]
            },
            children: null,
        },
        {
            name: 'locations',
            path: '/locations',
            component: Locations,
            icon: 'mdi-map-marker-radius',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2,7]
            },
            children: null
        },
        {
            name: 'maps',
            path: '/maps',
            component: Maps,
            icon: 'mdi-google-maps',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2,9]
            },
            children: null,
        },
        {
            name: 'parking',
            path: '/parking/:idLocation',
            component: Parking,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: ['*']
            },
            children: null,
        },
        {
            name: 'users',
            path: '/users',
            component: Users,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2]
            },
            children: null,
        },
        {
            name: 'dashboard',
            path: '/dashboard',
            component: Dashboard,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2]
            },
            children: null,
        },
        {
            name: 'avisos',
            path: '/avisos',
            component: Avisos,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2,5]
            },
            children: null,
        },
        {
            name: 'menu',
            path: '/menu',
            component: Menu,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                // Se agregan permisos para role 'MENU'
                roles: [2, 6]
            },
            children: null,
        },
        {
            name: 'carsReport',
            path: '/carsReport',
            component: CarsReport,
            icon: 'mdi-home',
            showInMenu: true,
            meta: {
                isAuhorizationRequires: true,
                roles: [2,7]
            },
            children: null,
        },
        {
            name: 'submenu',
            path: '/submenu/:idMenu/:name',
            component: SubMenu,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: ['*']
            },
            children: null,
        },
        {
            name: 'carsForReservation',
            path: '/carsForReservation/:idLocation',
            component: CarsForReservation,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: [2,7]
            },
            children: null,
        },
        {
            name: 'surveyDashboard',
            path: '/surveyDashboard/:surveyId',
            component: SurveyDashboard,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: [2]
            },
            children: null,
        },
        {
            name: 'bikesForReservation',
            path: '/bikesForReservation/:idLocation',
            component: BikesForReservation,
            icon: 'mdi-home',
            showInMenu: false,
            meta: {
                isAuhorizationRequires: true,
                roles: [2,7]
            },
            children: null,
        },
    ]
})
Vue.use(VueRouterBackButton, { router })

router.beforeEach((to, from, next) => {
    let isLoggedIn = store.getters['isSignedIn']
    let userProfiles = store.getters["roles"];
    console.log(userProfiles);
    //** console.log("isLoggedIn:" + isLoggedIn)
    if (to.matched.length === 0) {
        // La ruta no existe
        // Redirecciona el trafico del portal adis PQIT
        let adis_pqit_base_url = '/pqit-adis-portal/'
        if (to.fullPath.includes(adis_pqit_base_url)){
            window.location.href = 'https://adis-admin.mx'.concat(adis_pqit_base_url) ;
        }else{
            next('/404')
        } 
    } else if (isLoggedIn) {
        if (to.name === 'signin') {
            // Si el usuario solicito ir a SINGIN
            // pero ya existe una sesión abierta
            // ir directamente al HOME
            next('/')
        } else {
            // Validacion de roles
            let { roles = ["*"]} = to.meta;
            // Validamos si el role del usuario actual está cosiderado
            // dentro de los roles que tienen acceso al módulo
            let isAllow = roles.find((r) => r === "*" || userProfiles.find((element) => element === r));

            if (isAllow) {
                // El role tiene acceso al módulo
                next();
            } else {
                // El role no tiene acceso al módulo solicitado, por lo que
                // no se le permite el acceso y se redirecciona a la pantalla
                // de forbidden
                next("/403");
            }
        }
    } else {
        //
        // El usuario no ha iniciado sesión
        //
        if (!to.meta.isAuhorizationRequires) {
            // Ingreso a una sección que no requiere
            // una sesión de usuario
            next()
        } else {
            // Esta ingresando a una  sección que requiere
            // que el usuario complete el proceso de SIGIN
            next('/signin')
                // next()
        }
    }
})

export default router